<instant-proof order-item-id="{{currentItem.id}}" product-id="{{currentItem.productIdWithPrefix}}" product-name="{{currentItem.name}}"></instant-proof>
{{!-- <instant-proof order-item-id="5254614" product-id="{{currentItem.productIdWithPrefix}}" product-name="{{currentItem.name}}"></instant-proof> --}}
